<template>
  <div class="cxm-Pagination">
    <PaginationItemsCount
      :count-items="rowsPerPage"
      @change="handleChangeRowsPerPage"
    />
    <PaginationButtons
      v-show="loading === false"
      :page="page"
      :count-items="rowsPerPage"
      :total-items="rowsCount"
      @change="handleChangePage"
    />
    <PaginationItemsRange
      :page="page"
      :count-items="rowsPerPage"
      :loading="loading"
      :total-items="rowsCount"
    />
  </div>
</template>

<script>
import PaginationItemsCount from './PaginationItemsCount.vue';
import PaginationButtons from './PaginationButtons.vue';
import PaginationItemsRange from './PaginationItemsRange.vue';

export default {
  components: {
    PaginationItemsCount,
    PaginationButtons,
    PaginationItemsRange,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    rowsCount: {
      type: Number,
      default: 0,
    },
    rowsPerPage: {
      type: Number,
      default: 0,
    },
    rowsOffset: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      pagination: {
        rowsOffset: 0,
        rowsPerPage: 0,
      },
    };
  },
  computed: {
    page() {
      return Math.ceil(this.rowsOffset / this.rowsPerPage) + 1;
    },
  },
  mounted() {
    this.pagination = {
      rowsOffset: this.rowsOffset,
      rowsPerPage: this.rowsPerPage,
    };
  },
  methods: {
    emit() {
      const { rowsOffset, rowsPerPage } = this.pagination;
      this.$emit('change', {
        rowsOffset,
        rowsPerPage,
      });
    },
    handleChangePage(value) {
      const { rowsPerPage } = this.pagination;
      this.pagination.rowsOffset = value * rowsPerPage - rowsPerPage;
      this.emit();
    },
    handleChangeRowsPerPage(value) {
      this.pagination.rowsOffset = 0;
      this.pagination.rowsPerPage = value;
      this.emit();
    },
  },
};
</script>

<style scoped lang="scss">
.cxm-Pagination {
  align-items: center;
  display: flex;
  justify-content: space-between;
}
</style>
